<template>
  <div class="areaManagement modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png" alt="菜单" />
      </div>
      <div class="caidan-title">片区管理</div>
    </div>
    <div class="areaManagement_toolbar">
        <el-button type="primary" plain @click="addClick">新增</el-button>
    </div>
    <el-table
      class="tableStyle"
      v-loading="loading"
      ref="multipleTable"
      height="calc(100vh - 250px)"
      border
      style="width: 100%"
      :data="tableData"
      :header-cell-style="{
        background: '#FAFAFA',
        color: '#000000',
        'text-align': 'left'
      }"
    >
      <el-table-column label="序号" type="index" width="60"></el-table-column>
      <el-table-column prop="scopeName" label="片区名称" align="left"></el-table-column>
      
      <el-table-column label="操作" width="100px" align="left">
        <template #default="scope">
          <el-button class="btn" type="text" @click="editRow(scope.row)">编辑</el-button>
          <el-button class="btn" type="text" @click="delRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="addVisible"
      width="38%"
      v-if="addVisible"
      :close-on-click-modal="false"
    >
        <template slot="title">
            <div class="modul-top1">
                <div class="caidan-img">
                    <img src="../../../assets/image/caidan.png" alt="菜单" />
                </div>
                <div class="caidan-title">新增</div>
            </div>
        </template>
        <el-form :model="validateForm" ref="validateForm" label-width="100px">
            <el-form-item
                prop="scopeName"
                label="片区名称"
                :rules="[
                    { required: true, message: '请输入片区名称', trigger: 'blur' },
                ]"
            >
                <el-input v-model="validateForm.scopeName"></el-input>
            </el-form-item>
            <el-form-item
                label="片区范围"
                prop="scopePoints"
                :rules="[{required: true, message: '片区范围不能为空', trigger: 'blur'}]"
            >
            <template slot="error">
                <span class="el-form-item__error">片区范围不能为空</span>
            </template>
                <el-button type="primary" @click.prevent="scopeDrawing()">范围绘制</el-button>
            </el-form-item>
        </el-form>
      <div slot="footer" class="anniu">
        <el-button type="primary" @click="add_sure()">确 定</el-button>
        <el-button @click="addVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :modal-append-to-body="false"
      :visible.sync="mapVisible"
      width="68%"
      v-if="mapVisible"
      top="4vh"
      :close-on-click-modal="false"
    >
        <template slot="title">
            <div class="modul-top1">
                <div class="caidan-img">
                    <img src="../../../assets/image/caidan.png" alt="菜单" />
                </div>
                <div class="caidan-title">范围绘制</div>
            </div>
        </template>
        <div id="Map"></div>
        <template slot="footer">
            <el-button type="primary" @click="drawPolygon()">新 建</el-button>
            <el-button type="primary" @click="endPolygon()">结束编辑</el-button>
            <el-button type="primary" @click="submitMap()">确 定</el-button>
            <el-button @click="mapVisible = false">取 消</el-button>
        </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data(){
        return{
            tableData:[],
            loading:false,
            currentPage:{
                total:0,
                pageNum:1,
                pageSize:10,
            },
            addVisible:false,
            mapVisible:false,
            validateForm:{
                scopePoints:[]
            },
            map: null,
            mouseTool:null,
            polyEditor:null,
            mapVisible:false,
            newPath:[],
            isEdit:false,
        }
    },
    created(){
        this.getList()
    },
    methods:{
        async getList(){
            try{
                this.loading = true
                const res = await this.$api.sendPost('/scope/list',{})
                if(res.errcode == 0){
                    this.tableData = res.data
                }
            }catch{

            }finally{
                this.loading = false
            }
            
        },
        addClick(){
            this.validateForm = {
                scopePoints:[]
            }
            this.addVisible = true
        },
        scopeDrawing(){
            this.mapVisible = true
            this.newPath = []
            this.isEdit = false
            this.$nextTick(()=>{
                this.init()
            })
        },
        editRow(row){
            this.validateForm = JSON.parse(JSON.stringify(row))
            this.validateForm.scopePoints = JSON.parse(row.scopePoints)
            this.addVisible = true
        },
        async delRow(row){
            const res = await this.$api.sendGet('/scope/delete',{id:row.id})
            if(res.errcode == 0){
                this.$message.success("操作成功")
                this.getList()
            }else{
                this.$message.error(res.errmsg || "操作失败")
            }
            
        },
        add_sure(){
            this.$refs.validateForm.validate(async (valid) => {
                if (valid) {
                    let form = JSON.parse(JSON.stringify(this.validateForm))
                    form.scopePoints = JSON.stringify(this.validateForm.scopePoints)
                    const res = await this.$api.sendPost('/scope/insertOrUpdate', form)
                    if(res.errcode == 0){
                        this.$message.success("操作成功")
                        this.addVisible = false
                        this.getList()
                    }else{
                        this.$message.error(res.errmsg || "操作失败")
                    }
                } else {
                    return false;
                }
            });
        },
        init() {
            this.map = new AMap.Map('Map', {
                mapStyle: 'amap://styles/c39263cd8a72e6a697b238d3e49b7949',
                zoom: 14,
                expandZoomRange: true,
                zooms: [1, 20],
                resizeEnable: false, //是否监控地图容器尺寸变化
                center: [120.21633, 29.705383],
                viewMode: '2D',
            });
            this.mouseTool = new AMap.MouseTool(this.map)
            if(this.validateForm.scopePoints.length){
                let polyline=new AMap.Polygon({
                    path: this.validateForm.scopePoints.map(e =>{
                        return new AMap.LngLat(e.lng,e.lat)
                    }),     //设置折线的节点数组
                    strokeColor: "#3366FF",
                    strokeOpacity: 1,
                    strokeWeight: 4,
                    fillOpacity: 0.4,
                    fillColor: '#1791fc',
                    zIndex: 50,
                }); 
                this.map.add(polyline)
                this.map.setFitView()
                this.polyEditor = new AMap.PolyEditor(this.map,polyline);
                this.polyEditor.open();
                this.isEdit = true
            }
       
        },
        drawPolygon () {
            this.mouseTool.on('draw', (event)=> {
                // event.obj 为绘制出来的覆盖物对象
                console.log(event)
                this.polyEditor = new AMap.PolyEditor(this.map,event.obj);
                this.polyEditor.open();
                this.isEdit = true
                
            })
            this.mouseTool.polygon({
                strokeColor: "#3366FF",
                strokeOpacity: 1,
                strokeWeight: 4,
                // 线样式还支持 'dashed'
                strokeStyle: "solid",
                // strokeStyle是dashed时有效
                // strokeDasharray: [10, 5],
            })
        },
        endPolygon() {
            if(!this.isEdit)return this.$message.warning("请绘制片区")
            this.polyEditor.on("end", ({type,target}) => {
                this.newPath = target.getPath();
                
                console.log("结束编辑", this.newPath);
            });
            this.polyEditor.close();
            this.isEdit = false
        },
        submitMap(){
            if(!this.isEdit && this.newPath.length == 0) return this.$message.warning("请绘制片区")
            if(this.isEdit)this.endPolygon()
            this.validateForm.scopePoints = this.newPath
            this.mapVisible = false
        },
        
    },
}
</script>

<style lang="scss" scoped>
.areaManagement{
    .areaManagement_toolbar{
        height: 56px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .el-form{
        ::v-deep .el-form-item__content{
            display: flex;
        }
    }
    #Map{
        width: 100%;
        height: 70vh;
    }
    
}
</style>